import InputTimePicker from "../../BaseComponents/InputTimePicker/InputTimePicker";

import asInputField from "../../InputfieldHOC/InputfieldHOC";

const InputTimePickerField = asInputField(InputTimePicker);

export default InputTimePickerField;
